import { useRef, useState } from 'react'

const useTimer = () => {
  const rafRef = useRef(null)
  let startTime = useRef(null)
  const valueInitial = useRef(0)
  const stopped = useRef(true)
  const paused = useRef(true)
  const [currentValue, setCurrentValue] = useState(valueInitial.current)

  const onTick = () => {
    const timestamp = Date.now()

    if (stopped.current || paused.current) {
      return
    }

    if (!startTime.current) {
      startTime = Date.now()
    }

    setCurrentValue(valueInitial.current + timestamp - startTime.current)

    rafRef.current = window.requestAnimationFrame(onTick)
  }

  const init = () => {
    stopped.current = false
    paused.current = false
    startTime.current = Date.now()
    rafRef.current = window.requestAnimationFrame(onTick)
  }

  const pause = () => {
    paused.current = true
    valueInitial.current = currentValue
    window.cancelAnimationFrame(rafRef.current)
  }

  const resume = () => {
    if (!stopped.current) {
      paused.current = false
      startTime.current = Date.now()
      rafRef.current = window.requestAnimationFrame(onTick)
    }
  }

  const reset = () => {
    set(0)
    valueInitial.current = 0
    setCurrentValue(0)
    paused.current = null
  }

  const stop = () => {
    stopped.current = true
    pause()
    reset()
  }

  const set = value => {
    startTime.current = Date.now() - value
  }

  return {
    value: currentValue,
    init,
    pause,
    resume,
    reset,
    stop,
    set,
    paused: paused.current
  }
}
export default useTimer
